/**
 * Flags de funcionalidades y constantes de SMS.
 * WhatsApp queda OCULTO (sin borrar el código): pon whatsapp:true para reactivarlo.
 */
export const FEATURES = {
  whatsapp: false, // click-to-chat de WhatsApp (oculto, reactivable)
  sms: true,       // herramienta nativa "Enviar SMS" de Zicasso
};

export const SMS = {
  prefix: "Zicasso: ",        // Zicasso antepone esto al cuerpo del SMS
  maxLength: 640,             // límite de caracteres de Zicasso
  fromNumber: "+1 941 415 6509",  // número SMS del partner (Espíritu Travel)
  companyPhone: "+1 800 387 1370", // teléfono de empresa que se incluye en el texto
};
